import { useEffect, useState, useContext } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { API, AuthContext } from "../App";

const VerifyPage = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("verifying");
  const [message, setMessage] = useState("");
  const { setToken, setUser } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    const verifyEmail = async () => {
      const token = searchParams.get("token");

      if (!token) {
        setStatus("error");
        setMessage("No verification token provided");
        return;
      }

      try {
        const response = await axios.get(`${API}/auth/verify?token=${token}`);
        const data = response.data || {};
        const access = data.access_token || data.token;

        // Auto-login the user using the freshly-issued session token
        if (access) {
          try {
            sessionStorage.setItem("token", access);
            // Optimistic user object — we'll let App.js refetch via /auth/me on mount
            const u = { user_id: data.user_id, username: data.username, is_admin: !!data.is_admin, is_moderator: !!data.is_moderator };
            sessionStorage.setItem("user", JSON.stringify(u));
            setToken?.(access);
            setUser?.(u);
          } catch (_) { /* noop */ }
        }

        setStatus("success");
        setMessage(data.message || "Email verified! Welcome to MEGA! Chat.");

        // Redirect to the lobby after a brief celebration moment
        setTimeout(() => {
          navigate("/", { replace: true });
        }, 1500);
      } catch (error) {
        setStatus("error");
        const detail = error.response?.data?.detail;
        setMessage(typeof detail === "string" ? detail : "Verification failed");
      }
    };

    verifyEmail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0a0a1f] via-[#1a0a3e] to-[#3a0a5c] flex items-center justify-center p-4 relative overflow-hidden">
      {/* Decorative giant centered logo */}
      <img
        src="https://customer-assets.emergentagent.com/job_80904b6f-7286-4784-ad3d-292b160c5a80/artifacts/crjane52_MEGA%20CHAT%20LOGO.png"
        alt=""
        aria-hidden="true"
        className="absolute inset-0 m-auto w-[80vmin] h-[80vmin] object-contain opacity-[0.08] pointer-events-none select-none"
      />
      <div className="retro-window w-full max-w-md relative z-10 shadow-2xl shadow-black/50" data-testid="verify-window">
        <div className="retro-title-bar">
          <span>MEGA! Chat - Email Verification</span>
        </div>

        <div className="p-6 bg-[#C0C0C0]">
          <div className="text-center mb-6">
            <h1 className="yahoo-logo text-4xl mb-2">MEGA!</h1>
          </div>

          <div className="retro-inset p-6 text-center">
            {status === "verifying" && (
              <div data-testid="verify-loading">
                <p className="font-verdana text-sm">Verifying your email...</p>
                <div className="mt-4 flex justify-center gap-1">
                  <span className="typing-dot">●</span>
                  <span className="typing-dot">●</span>
                  <span className="typing-dot">●</span>
                </div>
              </div>
            )}

            {status === "success" && (
              <div data-testid="verify-success">
                <div className="text-4xl mb-4">✓</div>
                <p className="font-verdana text-sm text-green-700 font-bold mb-2">{message}</p>
                <p className="text-xs text-[#666] mb-4">Bringing you to the lobby...</p>
                <Link
                  to="/"
                  className="retro-button inline-block mt-2"
                  data-testid="verify-lobby-btn"
                >
                  Enter Now
                </Link>
              </div>
            )}

            {status === "error" && (
              <div data-testid="verify-error">
                <div className="text-4xl mb-4 text-red-600">✗</div>
                <p className="font-verdana text-sm text-red-700 font-bold">{message}</p>
                <Link
                  to="/register"
                  className="retro-button inline-block mt-4"
                  data-testid="verify-register-btn"
                >
                  Try Again
                </Link>
              </div>
            )}
          </div>

          <div className="mt-4 text-center">
            <p className="font-arial text-xs text-[#808080]">created by mr_fuker</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyPage;
